import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Drawer from 'material-ui/Drawer';
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
import { Link } from 'react-router';
import styles from './styles/leftDrawerStyles';
import { List, ListItem } from 'material-ui/List';
import Home from 'material-ui/svg-icons/action/home';
import Car from 'material-ui/svg-icons/maps/directions-car';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import * as settings from 'settings/settings';

class LeftDrawerList extends Component {

  render() {

    const { navDrawerOpen, translate, currentUserName } = this.props;

    //  PredictivePhysicalDamageV2 check
    const canSeeV2 =
      settings.PredictivePhysicalDamageV2Users &&
      settings.PredictivePhysicalDamageV2Users.some(
        user =>
          user.toLowerCase() ===
          (currentUserName || '').toLowerCase()
      );

    // Base nested items
    const crashDashboardItems = [
      <ListItem
        key={0}
        insetChildren={true}
        style={styles.menuItem}
        primaryText={translate('MENU.ICN')}
        disabled={false}
        containerElement={<Link to={"/instantcrashalerts"} />}
      />,
      <ListItem
        key={1}
        insetChildren={true}
        style={styles.menuItem}
        primaryText={translate('MENU.ICNPlus')}
        disabled={false}
        containerElement={<Link to={"/accidentreconstruction"} />}
      />,
      <ListItem
        key={2}
        insetChildren={true}
        style={styles.menuItem}
        primaryText={translate('MENU.dent')}
        disabled={false}
        containerElement={<Link to={"/predictivephysicaldamage"} />}
      />
    ];

    //  Add V2 only if allowed
    if (canSeeV2) {
      crashDashboardItems.push(
        <ListItem
          key={3}
          insetChildren={true}
          style={styles.menuItem}
          primaryText={translate('MENU.dentV2')}
          disabled={false}
          containerElement={<Link to={"/predictivephysicaldamage?v=2"} />}
        />
      );
    }

    return (
      <Drawer docked={true} open={navDrawerOpen}>
        <div style={styles.logo}>
          CrashBoxx
        </div>

        <List>

          <ListItem
            style={styles.menuItem}
            primaryText={translate('MENU.home')}
            leftIcon={<Home />}
            containerElement={<Link to={"/"} />}
          />

          <ListItem
            style={styles.menuItem}
            primaryText={translate('MENU.crashDashboard')}
            leftIcon={<Car />}
            rightIcon={<ArrowDropRight />}
            containerElement={<Link to={"/crash"} />}
            primaryTogglesNestedList={true}
            nestedItems={crashDashboardItems}
          />

        </List>
      </Drawer>
    );
  }
}

LeftDrawerList.propTypes = {
  navDrawerOpen: PropTypes.bool
};

function mapStateToProps(state) {
  const currentUser =
    state.user &&
    state.user.currentUser;

  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    currentUserName: currentUser ? currentUser.username : ''
  };
}

export default connect(mapStateToProps)(LeftDrawerList);



// WEBPACK FOOTER //
// ./src/containers/layout/LeftDrawerList.js